//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'

import ImgWrap from '@/components/business/img_wrap'
import type_name from '@/components/mixins/building_ranking'
export default {
    name: 'WHOLE_BUILDING_ITEM',
    mixins: [
        type_name
    ],
    components: {
        ImgWrap
    },
    props: {
        item: {
            type: Object
        },
        comment: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        show_presell_date () {
            return Boolean(this.item && (this.item.estimated_presell_time && this.item.status === '即将取证'))
        },
        center () {
            return (this.item.price_desc_arr && this.item.price_desc_arr.length === 0)
                || (this.item.tags && this.item.tags.length === 0)
        },
        is_price_empty () {
            return this.item.price_desc_arr && this.item.price_desc_arr.length === 0
        }
    },
    methods: {
        getItemTag (condition) {
            return this.item && this.item.tags ? this.item.tags.filter(condition) : []
        },
        goDetail (e) {
            const { log_id, href, position } = this.item
            this.$router.push({
                path: href
            })
            if (log_id) {
                Service.interestingEvent({
                    interesting_id: log_id,
                    event: 'click',
                    pos_name: position,
                    pos: this.index || 0
                })
            }
        }
    }
}
